import quickaccess from "./quickaccess";
import services from "./services";
import social from "./social";
// import other from "./other";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [quickaccess, services, social],
};

export default menuItems;
